// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"6c631592b062436d4eb5","691":"6662efefe577408686c2","731":"68f6335fd2a5bd50e4f9","843":"aad404c08e843630b3c5"}[chunkId] + ".js";
};